<template>
  <div>
    <RelatorioPaisagem>
      <b-card class="fundoRelatorio cabecalhoTable">
        <div v-for="(linhaDaTabela, indice) in parametro.dados" :key="`tabelaItem_${indice}`">
          <div class="fundoRelatorio titulo">
            <div class="d-none d-lg-flex align-items-center fundoRelatorio">
              <img :src="logoAgenda" alt="logoAgenda" />

              <h2 class="brand-text text-primary ml-1" style="margin-bottom: 0px; margin-left: 0px !important">Agenda Bank</h2>
            </div>
            <div class="lineBlue"></div>
            <div class="lineGray"></div>
            <h1 class="fundoRelatorio instituto" style="margin-bottom: 0px; margin-top: 5px">
              {{ parametro.institutoNome }}
            </h1>
          </div>

          <!-- Nome do Relatório -->
          <div class="fundoRelatorio tituloRelatorio">Extrato de {{ parametro.titulo }}</div>

          <h3 style="margin-bottom: 0px; margin-top: 5px; font-size: 0.8rem">Competência: {{ parametro.competencia }}</h3>
          <h3 style="margin-bottom: 0px; margin-top: 5px; font-size: 0.8rem">Órgão: {{ parametro.orgao }}</h3>

          <b-table
            striped
            small
            class="ExportarPDFParcela mt-3"
            :class="parametro.dados.length - 1 == indice ? 'UltimaTable' : ''"
            style="text-align: center"
            id="table_export_id"
            :head-variant="'light'"
            :items="linhaDaTabela"
            :fields="parametro.colunas"
          >
            <template #cell(nomeCompleto)="row">
              {{ row.item.financeiro.segurado.tomador.nomeCompleto }}
            </template>

            <template #cell(cpf)="row">
              {{ row.item.financeiro.segurado.tomador.cpf }}
            </template>

            <template #cell(dataNascimento)="row">
              {{ formatarData(row.item.dataNascimento) }}
            </template>

            <template #cell(matricula)="row">
              {{ row.item.financeiro.segurado.matricula }}
            </template>

            <template #cell(categoria)="row">
              {{ row.item.financeiro.segurado.situacaoPrevidenciaria }}
            </template>

            <template #cell(valorTotalParcela)="row">
              {{ formatarValor(row.item.valor) }}
            </template>

            <template #cell(descontoRealizado)="row">
              {{ row.item.descontoRealizado ? formatarValor(row.item.descontoRealizado) : formatarValor(0) }}
            </template>

            <template #cell(valorAPagar)="row">
              {{ formatarValor(row.item.valor - row.item.descontoRealizado) }}
            </template>

            <template #cell(contratoNumero)="row">
              {{ row.item.financeiro.codigo }}
            </template>

            <template #cell(periodo)="row">
              {{ String(row.item.competencia).substring(4, 6) + '/' + String(row.item.competencia).substring(0, 4) }}
            </template>

            <template #cell(status)="row">
              <b-badge :variant="statusMap[row.item.statusDesconto][1]">
                {{ statusMap[row.item.statusDesconto][0] }}
              </b-badge>
            </template>
          </b-table>

          <div v-if="parametro.dados.length - 1 == indice && linhaDaTabela.length == 22" class="html2pdf__page-break" />
          <div v-if="parametro.dados.length - 1 != indice" class="html2pdf__page-break" />
        </div>
      </b-card>
    </RelatorioPaisagem>
  </div>
</template>

<script>
  import pdfMake from 'pdfmake/build/pdfmake'
  import pdfFonts from 'pdfmake/build/vfs_fonts'
  import RelatorioPaisagem from '@/views/pages/relatorio/relatorioPaisagem.vue'
  import { formatarData, formatarParaNumber, formatarValor } from '@/libs/utils'

  export default {
    components: {
      RelatorioPaisagem,
      pdfMake,
      pdfFonts,
      formatarValor,
      formatarData,
    },
    props: {
      parametro: {},
    },
    data() {
      return {
        aImg: require('@/assets/images/logo/Alogo2.png'),
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,

        formatarValor,
        formatarData,

        statusMap: {
          Descontado: ['Parcela Descontada', 'success'],
          Rejeitada: ['Parcela Rejeitada', 'danger'],
          PagaParcialmente: ['Paga Parcialmente', 'warning'],
          NaoDescontada: ['Não Descontada', 'secondary'],
        },
      }
    },
    computed: {
      logoAgenda() {
        return this.userData.Instituto?.logoRelatorio?.logo ?? this.aImg
      },
    },
  }
</script>

<style scoped>
  .fundoRelatorio {
    background-color: white;
    word-break: break-word;
  }

  .titulo {
    background-color: inherit !important;
    justify-content: flex-start;
    word-break: break-all;
    padding-top: 5px;
  }

  .ExportarPDFParcela .thead-light th {
    background-color: #f3f2f700 !important;
    border-color: #4941a6;
    border-block-start: initial;
    color: #4941a6;
    font-size: 10px;
    padding: 10.5px 0;
    inline-size: max-content;
  }

  .lineBlue {
    width: 288px;
    height: 13px;
    background-color: #4941a6;
  }
  .lineGray {
    width: 563px;
    height: 13px;
    background-color: #b8c2cb;
  }
  .instituto {
    font-size: initial;
    padding-left: 20px;
  }
  .tituloRelatorio {
    text-align: center;
    font-weight: bold;
    font-size: large;
    color: #615771;
  }
  .cabecalhoTable {
    margin-bottom: 0px;
    font-size: 9px;
    word-wrap: normal;
    white-space: pre-wrap;
  }

  .periodoRelatorio {
    font-weight: bold;
    color: black;
    text-align: center;
  }

  .totalParcelas {
    font-weight: bold;
    color: black;
    font-size: 9px;
    padding-bottom: 2px;
    padding-left: 20px;
  }

  .rodapeRelatorio {
    font-size: 11px;
    margin-bottom: 0px;
    color: #736c81;
    margin-top: 5px;
    padding-left: 20px;
  }

  .rodapeRelatorioContainer {
    bottom: 0rem;
  }

  .content-wrapper {
    position: relative;
  }

  /* .bold-footer-row {
    font-weight: bold;
  } */

  #ExportarPDFParcelaId thead tr th {
    width: 100px;
  }

  #ExportarPDFParcelaId tbody tr td {
    padding: 3px !important;
  }

  /* .UltimaTable tbody tr:last-child {
    font-weight: bold;
  } */

  #logoAgenda {
    margin: 0 10px;
  }

  div.vue-html2pdf div.card-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .ExportarPDFParcela {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
  }

  .margemTotalizador {
    margin-top: 30px;
  }

  .ExportarPDFParcela tbody tr td {
    text-wrap: nowrap;
  }

  .mt-07 {
    margin-top: 0.7rem !important;
  }

  .mt-05 {
    margin-top: 0.5rem !important;
  }

  #radiosTipoDePesquisa > label {
    width: 0.5em;
  }

  #ExportarPDFParcelaId thead > tr > th > div {
    font-size: 0.6rem !important;
    background-color: red;
  }

  #ExportarPDFParcelaId tbody > tr > td {
    font-size: 0.55rem !important;
  }
</style>
